module.exports = __webpack_public_path__ + "img/service-icon-3.648fd1af.png";